import s from './style.css';
import Container from 'components/Container';
import Logo from 'components/Logo';

const Footer = () => (
	<div className={s.root}>
		<Container>
			<p className={s.logo}>
				<Logo trim />
			</p>
			<p>
				<strong>Survey data</strong> <br />Totaljobs research of 5,795 UK
				workers in Febuary 2018.
			</p>
		</Container>
	</div>
);

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/index.js